import { render } from "./AddReturn.vue?vue&type=template&id=9643604e&ts=true"
import script from "./AddReturn.vue?vue&type=script&lang=ts"
export * from "./AddReturn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__